function SectionCandidateEducation() {
    return (
        <>
            <h4 className="twm-s-title">Education &amp; Training</h4>
            <div className="twm-timing-list-wrap">
                <div className="twm-timing-list">
                    <div className="twm-time-list-date">2004 to 2006</div>
                    <div className="twm-time-list-title">BCA - Bachelor of Computer Applications</div>
                    <div className="twm-time-list-position">International University</div>
                    <div className="twm-time-list-discription">
                        <p>One of the main areas that I work on with my clients is shedding these non-supportive beliefs and
                            replacing them with beliefs that will help them to accomplish their desires.</p>
                    </div>
                </div>
                <div className="twm-timing-list">
                    <div className="twm-time-list-date">2006 to 2008</div>
                    <div className="twm-time-list-title">MCA - Master of Computer Application</div>
                    <div className="twm-time-list-position">Middle East Technical University</div>
                    <div className="twm-time-list-discription">
                        <p>One of the main areas that I work on with my clients is shedding these non-supportive beliefs and
                            replacing them with beliefs that will help them to accomplish their desires.</p>
                    </div>
                </div>
                <div className="twm-timing-list">
                    <div className="twm-time-list-date">2008 to 2011</div>
                    <div className="twm-time-list-title">Design Communication Visual</div>
                    <div className="twm-time-list-position">Design at Massachusetts Institute of Technology &amp; Marketing</div>
                    <div className="twm-time-list-discription">
                        <p>One of the main areas that I work on with my clients is shedding these non-supportive beliefs and
                            replacing them with beliefs that will help them to accomplish their desires.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionCandidateEducation;